<template>
	<div class="cog-checkable cog-input cog-checkable--inline" :class="{'is-read-only': readonly}">
		<div v-if="readonly">{{ displayValue || "&nbsp;" }}</div>
		<el-checkbox
			v-else
			:id="fullId"
			v-model="internalValue"
			v-bind="$attrs"
			:label="label"
			class="cog-choice-option"
			:aria-required="isRequired ? true : undefined"
			:aria-describedby="ariaDescriptions"
			:aria-invalid="hasError ? true : undefined"
			@change="handleChange"
		>
			{{ label }}
		</el-checkbox>
	</div>
</template>

<script>
	import '../style/_checkables.scss';

	import Vue from 'vue';
	import { Checkbox } from '@cognitoforms/element-ui';

	Vue.use(Checkbox);

	export default Vue.extend({
		name: 'CCheckbox',
		inject: {
			fieldContext: { default: () => () => ({ id: null, hasError: false, isRequired: false }) }
		},
		inheritAttrs: false,
		model: {
			prop: 'checked',
			event: 'change'
		},
		props: {
			id: { type: String, default: null },
			label: { type: String, default: '' },
			checked: Boolean,
			readonly: Boolean,
			activeText: { type: String, default: '' },
			inactiveText: { type: String, default: '' }
		},
		data: function () {
			return {
				hasFocus: false,
				internalValue: this.checked
			};
		},
		computed: {
			displayValue() {
				return this.internalValue ? this.activeText : this.inactiveText;
			},
			fullId() {
				return this.fieldContext().id ? 'cog-' + this.fieldContext().id : null;
			},
			hasError() {
				return this.fieldContext().hasError;
			},
			isRequired() {
				return this.fieldContext().isRequired;
			},
			hasHelptext() {
				return this.fieldContext().hasHelptext;
			},
			ariaDescriptions() {
				const ids = [
					this.hasError ? `${this.fullId}-error` : null,
					this.hasHelptext ? `${this.fullId}-helptext` : null
				].filter(Boolean);
				return ids.length ? ids.join(' ') : undefined;
			}
		},
		watch: {
			checked: function (checked) {
				this.internalValue = checked;
			}
		},
		methods: {
			handleChange(value, ev) {
				this.internalValue = value;
				this.$emit('change', value, ev);
			}
		}
	});
</script>
